import { render, staticRenderFns } from "./InvFixedAssets.vue?vue&type=template&id=8ecdede2&"
import script from "./InvFixedAssets.vue?vue&type=script&lang=js&"
export * from "./InvFixedAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports